var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7133 16.1428L17.5711 16.0194C17.1678 15.666 16.8147 15.2606 16.5215 14.8143C16.2013 14.1984 16.0094 13.5258 15.957 12.8359V10.804C15.9598 9.72047 15.5602 8.67321 14.8333 7.85902C14.1064 7.04483 13.1023 6.51975 12.0095 6.38243V5.85183C12.0095 5.7062 11.9507 5.56654 11.846 5.46356C11.7413 5.36059 11.5993 5.30273 11.4513 5.30273C11.3032 5.30273 11.1612 5.36059 11.0565 5.46356C10.9518 5.56654 10.893 5.7062 10.893 5.85183V6.39065C9.81007 6.53787 8.81806 7.06613 8.10072 7.87759C7.38338 8.68904 6.98932 9.72871 6.99152 10.804V12.8359C6.93915 13.5258 6.74722 14.1984 6.427 14.8143C6.13883 15.2595 5.79147 15.6648 5.39413 16.0194L5.25195 16.1428V17.3027H17.7133V16.1428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementLogo);
export default __webpack_public_path__ + "static/media/announcement-logo.fae6fa993b3f59f6ee05bb0404bd483b.svg";
export { ForwardRef as ReactComponent };